export default __webpack_public_path__ + "static/media/recicla.3d57475a.png";